import { Tree, TreeNode } from "@/types/tree";
import { findNode, parentNodesReduce, treeNodeReduce } from "@/lib/tree/tree";
import { uiStore } from "@/store/store-accessor";

export type StructurePanelNodeStateExpanded = undefined | true;
export type StructurePanelNodeStateCollapsed = false;

export type StructurePanelNodesExpandedState = {
  [key: string]:
    | StructurePanelNodeStateExpanded
    | StructurePanelNodeStateCollapsed;
};

export function expandOrCollapseAllNodes(
  tree: Tree,
  expand: boolean
): StructurePanelNodesExpandedState {
  return treeNodeReduce(
    (node, acc: StructurePanelNodesExpandedState) => {
      acc[node.id] = expand;
      return acc;
    },
    tree.root,
    {}
  );
}

export function expandNodesToShowActiveElement(
  tree: Tree,
  activeElementId: TreeNode["id"]
): StructurePanelNodesExpandedState | undefined {
  const activeNode = findNode(tree, activeElementId);

  if (!activeNode) return;

  return parentNodesReduce(
    (node, acc: StructurePanelNodesExpandedState) => {
      acc[node.id] = true;
      return acc;
    },
    tree,
    activeNode,
    {}
  );
}

export function structurePanelNodeIsCollapsed(nodeId: TreeNode["id"]) {
  return uiStore.structurePanelNodesExpandedState[nodeId] === false;
}

export function structurePanelNodeIsExpanded(nodeId: TreeNode["id"]) {
  return (
    uiStore.structurePanelNodesExpandedState[nodeId] === undefined ||
    uiStore.structurePanelNodesExpandedState[nodeId] === true
  );
}
